import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, inject, input, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AppStyle } from 'src/app/models/app-style.type';
import { OverlayDirective } from 'src/app/shared/overlay/overlay.directive';
import { FormatDateDistanceCompactPipe } from 'src/app/shared/pipes/format-date-distance-compact.pipe';
import { CellValue, MatsymbolCellValue } from '../../models/cell';
import { FormatDateDistancePipe } from '../../pipes/format-date-distance.pipe';
import { FormatDatePipe } from '../../pipes/format-date.pipe';
import { AppStyleService } from '../../services/app-style-service';
import { ColorService } from '../../services/color.service';

@Component({
  selector: 'pozi-cell-value',
  imports: [
    FormatDatePipe,
    FormatDateDistancePipe,
    FormatDateDistanceCompactPipe,
    RouterLink,
    OverlayDirective,
    NgTemplateOutlet,
  ],
  templateUrl: './cell-value.component.html',
  styleUrl: './cell-value.component.scss',
})
export class CellValueComponent {
  color = inject(ColorService);
  appStyleService = inject(AppStyleService);

  cellValue = input.required<CellValue>();

  // Until proper casting in template is possible
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value = computed(() => this.cellValue() as any);

  appStyle = signal<AppStyle>('default');

  constructor() {
    this.appStyle.set(this.appStyleService.getAppStyle());
  }

  getFontVariationSettingsForMatSymbol(
    matsymbolCellValue: MatsymbolCellValue
  ): string {
    return `'FILL' ${matsymbolCellValue.matsymbol.fill ? '1' : '0'}`;
  }
}
